/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Administration {
    
    @Serenity.Decorators.registerClass()
    export class UserLogGrid extends SiteEntityGrid<UserLogRow, any> {
        protected getColumnsKey() { return 'Administration.UserLog'; }
        protected getDialogType() { return UserLogDialog; }
        protected getIdProperty() { return UserLogRow.idProperty; }
        protected getLocalTextPrefix() { return UserLogRow.localTextPrefix; }
        protected getService() { return UserLogService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}